/*
https://github.com/themesberg/flowbite-icons
Flowbite Icons is free and open-source under the MIT License.
*/
import React from 'react';

interface Props {
    readonly className?: string;
}

export default function Reply({
    className = null,
}: Props) {
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
            <path d="M25.5594 8.85303H20.0057V6.76497C20.0241 5.85043 19.7826 4.9498 19.31 4.17032C18.8373 3.39084 18.1535 2.76536 17.3399 2.36835C16.6177 2.03604 15.8153 1.92522 15.0316 2.04957C14.248 2.17393 13.5174 2.52802 12.9302 3.06812L1.58062 13.1709C1.08239 13.6346 0.684648 14.198 0.412568 14.8254C0.140488 15.4529 0 16.1307 0 16.816C0 17.5013 0.140488 18.1791 0.412568 18.8066C0.684648 19.434 1.08239 19.9974 1.58062 20.4611L12.9302 30.5751C13.5182 31.1148 14.2492 31.4684 15.0332 31.5924C15.8171 31.7163 16.6198 31.6052 17.3421 31.2727C18.1569 30.8743 18.8413 30.2469 19.3136 29.4653C19.7859 28.6837 20.0261 27.7809 20.0057 26.8648V24.7767H22.2272C23.4189 24.7922 24.556 25.2857 25.3889 26.1492C26.2218 27.0127 26.6826 28.1755 26.6702 29.3826V35.7503C26.6702 36.0988 26.7502 36.4425 26.9038 36.7543C27.0574 37.0662 27.2804 37.3376 27.5552 37.5473C27.83 37.7569 28.1492 37.8991 28.4875 37.9625C28.8258 38.0259 29.1741 38.0088 29.5048 37.9126C32.8645 36.9069 35.757 34.7147 37.6576 31.7338C39.5581 28.7528 40.3407 25.1806 39.8634 21.6653C39.3861 18.1499 37.6806 14.9243 35.0562 12.5736C32.4318 10.2229 29.0625 8.90288 25.5594 8.85303Z" fill="currentColor" />
        </svg>
    );
}
